import initializeFolderViewStates from 'mini-mail-folder-store/lib/actions/data-loading/initializeFolderViewStates';
import openLeftNavPerfDatapointInitializer from 'mini-mail-list-store/lib/mutators/openLeftNavPerfDatapointInitialize';
import resetMailListFocus from 'mini-mail-list-store/lib/utils/resetMailListFocus';
import setShowFolderPane from 'mini-mail-folder-store/lib/actions/setShowFolderPane';
import { getStore as getFolderStore } from 'mini-mail-folder-store/lib/store/Store';

export const onOpenFolderPane = () => {
    openLeftNavPerfDatapointInitializer(true /*Initialising PerfDatapoint*/);
    if (!getFolderStore().folderNodeViewStates.size) {
        initializeFolderViewStates();
    }
    setShowFolderPane(true /*showFolderPane*/);
    resetMailListFocus();
};
